import ReactSquadCTA from 'features/react-squad/react-squad-boteatbrain-cta';
import ReactSquadHeader from 'features/react-squad/react-squad-boteatbrain-header';
import ReactSquadHero from 'features/react-squad/react-squad-boteatbrain-hero';
import ReactSquadPricing from 'features/react-squad/react-squad-boteatbrain-pricing';
import ReactSquadSteps from 'features/react-squad/react-squad-boteatbrain-steps';
import ReactSquadCompanies from 'features/react-squad/react-squad-companies';
import ReactSquadFAQ from 'features/react-squad/react-squad-faq';
import ReactSquadFeatures from 'features/react-squad/react-squad-features';
import ReactSquadFooter from 'features/react-squad/react-squad-footer';
import ReactSquadSkills from 'features/react-squad/react-squad-skills';
import { NextSeo } from 'next-seo';
import React from 'react';

export default function ReactSquad() {
  const SEO = {
    title: 'ReactSquad – React agency for SaaS startups',
    description:
      'Providing SaaS startups with specialized React developers (+ Next.js & Remix)',
    openGraph: {
      type: 'website',
      url: `${process.env.NEXT_PUBLIC_SITE_URL}/react-squad`,
      site_name: 'ReactSquad',
      title: 'ReactSquad – React agency for SaaS startups',
      description:
        'Providing SaaS startups with specialized React developers (+ Next.js & Remix)',
      images: [
        {
          url: `${process.env.NEXT_PUBLIC_SITE_URL}/assets/react-squad-meta.png`,
        },
      ],
    },
    canonicalUrl: `${process.env.NEXT_PUBLIC_SITE_URL}/releaselog`,
  };

  return (
    <div className="scroll-smooth bg-[#F6F6F6] font-inter">
      <NextSeo {...SEO} />
      <div className="relative bg-[#0F0F0F] bg-react-squad bg-[length:150%] bg-center bg-no-repeat sm:bg-[length:130%] lg:bg-contain">
        <ReactSquadHeader />
        <ReactSquadHero />
      </div>

      <div className="mx-auto px-2 md:container sm:w-full">
        <ReactSquadCompanies />
        <ReactSquadSteps />
        <ReactSquadFeatures />
      </div>
      <ReactSquadSkills />
      <div className="mx-auto px-2 md:container sm:w-full">
        <ReactSquadPricing />
        <ReactSquadFAQ />
      </div>
      <ReactSquadCTA />
      <ReactSquadFooter />
    </div>
  );
}
